<template>
	<label v-if="explanation === true" v-bind:for="id" :id="'label-'+id" class="control-label col-md-3 unselect" data-toggle="popover" data-placement="right" data-trigger="manual" :title="$t('misc.explanation')" :data-content="$t(scope+'.explanation.'+id)">{{$t(scope+'.values.'+id)}}</label>
	<label v-else v-bind:for="id" class="control-label col-md-3 unselect">{{$t(scope+'.values.'+id)}}</label>
</template>

<script>
import hoverintent from 'hoverintent/dist/hoverintent.min';
export default {
  name: "LabelInput",
  data() {
    return {
    };
  },
  props: ["id", "explanation", "scope"],
  mounted(){
	  if (this.explanation === true) {
		  $('#label-'+this.id).popover();
		  var el = document.getElementById('label-'+this.id);
		  hoverintent(el,
				  () => {
			  		$('#label-'+this.id).popover('show')
				  }, () => {
					  $('#label-'+this.id).popover('hide')  
		  }); 
	  }
  }
};
</script>

<style scoped>
</style>	


// WEBPACK FOOTER //
// src/components/input/LabelInput.vue